export default __webpack_public_path__ + "static/media/Mobile-Foundation.8422fc75.png";